import React from "react";

import { BarChart3 } from "lucide-react";

/**
 * Placeholder for Business KPI briefings (coming soon) — matches product mock.
 */
const BusinessKpiBriefingsPlaceholder: React.FC = () => {
  return (
    <div className="flex flex-col items-start px-6 py-12 md:px-10 md:py-16 max-w-2xl">
      <div
        className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-[rgba(151,74,228,0.12)] text-[#974ae4]"
        aria-hidden
      >
        <BarChart3 className="h-10 w-10" strokeWidth={1.5} />
      </div>
      <h2 className="text-xl font-semibold text-gray-900 mb-3">
        Business KPI Briefings
      </h2>
      <p className="text-sm leading-relaxed text-gray-600">
        Business KPI briefings are coming soon — AI-powered insights on pipeline
        health, internal business metrics, and custom KPIs sourced directly from
        your enterprise systems.
      </p>
    </div>
  );
};

export default BusinessKpiBriefingsPlaceholder;
